import { render, staticRenderFns } from "./ObratList.vue?vue&type=template&id=5f7545fe&"
import script from "./ObratList.vue?vue&type=script&lang=ts&"
export * from "./ObratList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports